/* no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isNull from 'lodash/isNull';
import { Header, ThemContainer} from './style';
// import { bannerThemeData } from '../../../../mockData';
import Waiting from '../../Waiting';
import { fetchMonthlyRewardsPoint } from '../../../redux/actions';
// const Days = [
//   "Sun",
//   "Mon",
//   "Tue",
//   "Wed",
//   "Thu",
//   "Fri",
//   "Sat"
// ];

class ThemeBanner extends Component {
  constructor() {
    super();
    this.state = {
      month: '',
      hideContent: false
    };
  }

  

  render() {
    const { monthlyRewardPoint, totalPoints, themesHeader } = this.props;
    // const d = new Date;
    // const date = new Date();
    // const day = date.getDay();
    if (isNull(monthlyRewardPoint) || isNull(totalPoints)) {
      return <Waiting />
    }
    // const themeStyle = themesHeader?themesHeader:[];
    // const currentMonth = new Date().getMonth();
    // const currentMonthTheme=bannerThemeData[currentMonth];
    return (
      <Header bgColor={themesHeader?.background_color} backgroundImage={"/web/svg/" + themesHeader?.image_url}>
        <ThemContainer bgColor={themesHeader?.background_color} >
          <div className='theme-text'>
            <p className="first">{themesHeader?.month}</p>
            <p className="last">{themesHeader?.theme_text}</p>
          </div>
        </ThemContainer>
      </Header>
    )
  }
}

ThemeBanner.propTypes = {
  history: PropTypes.object.isRequired,
  userDetails: PropTypes.object.isRequired,
  fetchMonthlyRewardsPoint: PropTypes.func,
  monthlyRewardPoint: PropTypes.number,
  totalPoints: PropTypes.object,
  companyInfo: PropTypes.object,
  isAdmin: PropTypes.bool,
  role: PropTypes.bool,
  userCompany: PropTypes.object,
  themesHeader: PropTypes.array
};

const mapStateToProps = (state) => ({
  monthlyRewardPoint: state.wellnessDashboard.monthlyRewardPoint,
  totalPoints: state.wellnessDashboard.reward,
  companyInfo: state.companyDashboard.companyInfo,
  themesHeader: state.profileData.themesHeader
});

const mapDispatchToProps = (dispatch) => ({
  fetchMonthlyRewardsPoint: (startDate) => dispatch(fetchMonthlyRewardsPoint(startDate))
})

export default connect(mapStateToProps, mapDispatchToProps)(ThemeBanner);
